var React = require('react');
var Router = require('react-router');
var productLogo = require('../../assets/images/product_logo.png');

module.exports = React.createClass({
  displayName: 'LogoTitle',

  render: function() {
    return (
      <div className="logo-container">
        <Router.Link to="/">
          <img src={productLogo} />
        </Router.Link>
      </div>
    )
  }
});



// WEBPACK FOOTER //
// ./src/components/LogoTitle.js